module.exports = __webpack_public_path__ + "img/taking.c42966bf.png";